import { combineReducers } from "redux";
import { getType, StateType } from "typesafe-actions";
import { STORAGE_AUTH_TOKEN } from "./../constants/storage";
import accountsReducer from "./modules/accounts/reducer";
import billingReducer from "./modules/billing/reducer";
import { logout } from "./modules/user/actions";
import userReducer from "./modules/user/reducer";
import { RootAction } from "./types.d";

declare global {
  interface Window {
    Intercom: any;
  }
}

const appReducer = combineReducers({
  user: userReducer,
  billing: billingReducer,
  accounts: accountsReducer,
});

export type RootState = StateType<typeof appReducer>;

const rootReducer = (state: RootState | undefined, action: RootAction) => {
  if (action.type === getType(logout)) {
    state = undefined;
    localStorage.removeItem(STORAGE_AUTH_TOKEN);
    if (window.Intercom) {
      window.Intercom("shutdown");
    }
  }
  return appReducer(state, action);
};

export default rootReducer;
